import { render } from "./PodlovePlayer.vue?vue&type=template&id=a376a06a"
import script from "./PodlovePlayer.vue?vue&type=script&lang=js"
export * from "./PodlovePlayer.vue?vue&type=script&lang=js"
script.render = render

export default script